import { tripPlannerDetails } from './trip-planner-details/trip-planner-details.module';
import { tripPlannerForm } from './trip-planner-form/trip-planner-form.module';
import { tripPlannerMain } from './trip-planner-main/trip-planner-main.module';
import { tripPlannerMobileMapView } from './trip-planner-mobile-map-view/trip-planner-mobile-map-view.module';
import { tripPlannerLandingPage } from './trip-planner-landing-page/trip-planner-landing-page.module';
import { tripPlannerProviderDetails } from './trip-planner-provider-details/trip-planner-provider-details.module';
import { tripPlannerMobileHelp } from './trip-planner-mobile-help/trip-planner-mobile-help.module';
import { TripPlannerService } from './trip-planner.service';
import './trip-planner.scss';

export const tripPlanner = angular
    .module('components.tripPlanner', [
        tripPlannerDetails,
        tripPlannerForm,
        tripPlannerMain,
        tripPlannerMobileMapView,
        tripPlannerLandingPage,
        tripPlannerProviderDetails,
        tripPlannerMobileHelp
    ])
    .service("TripPlannerService", TripPlannerService)
    .name;



// WEBPACK FOOTER //
// ./src/app/components/trip-planner/trip-planner.module.js